'use client';
import React from 'react';

const steps = [
  {
    heading: 'Map your assets and detect exposures.',
    description: 'Continuously discover infrastructure, pipelines, and new exposures before they become real risks.',
  },
  {
    heading: 'Secure every day, with expert precision.',
    description: 'AI-driven security assessments adapt to every change in your infrastructure and applications, replicating top security experts at machine speed.',
  },
  {
    heading: 'Remediate smarter, right at the code.',
    description: 'Accelerate remediation with offensive context, actionable guidance, and continuous validation of results.',
  },
];

export default function SecurityMapSection() {
  return (
    <section className="bg-[#050a0f] border-t border-[#222] py-20 lg:py-28 relative overflow-hidden">
      {/* Background orbs */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="orb orb-cyan" style={{ width: '450px', height: '450px', bottom: '-100px', right: '-50px', opacity: 0.35 }} />
      </div>

      <div className="relative z-10 max-w-[1440px] mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-24 mb-16">
          <div className="lg:w-1/2 fade-in-left">
            <h2 className="font-heading text-[clamp(2rem,4vw,3rem)] text-[#f5f5f8] font-medium leading-tight">
              Map every asset. Secure every change.
            </h2>
          </div>
          <div className="lg:w-1/2 flex items-end fade-in-right" style={{ transitionDelay: '0.15s' }}>
            <p className="text-[#aaa] text-base leading-relaxed">
              SecureOps AI agents map your entire attack surface and test it daily with expert-level precision.
            </p>
          </div>
        </div>

        {/* Content */}
        <div className="flex flex-col lg:flex-row gap-12">
          {/* Left: Dashboard image */}
          <div className="lg:w-1/2">
            <div className="border border-[#222] overflow-hidden">
              <img
                src="https://cdn.prod.website-files.com/68a77090b95f85ab69076143/68ffbe7b2bbb54ec1d79875a_d8a8e524648d2fb461d871174d2c5aa9_visibility.avif"
                alt="Table listing three vulnerabilities with high severity and impact, all marked as pending fix."
                className="w-full h-auto object-cover"
              />
            </div>
          </div>

          {/* Right: Steps */}
          <div className="lg:w-1/2 flex flex-col justify-center gap-0">
            {steps?.map((step, i) => (
              <div
                key={i}
                className={`py-8 ${
                  i < steps?.length - 1 ? 'border-b border-[#222]' : ''
                }`}
              >
                <h3 className="font-heading text-lg text-[#f5f5f8] font-medium mb-3">
                  {step?.heading}
                </h3>
                <p className="text-sm text-[#aaa] leading-relaxed">{step?.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
